import ArrayProxy from "@ember/array/proxy"
import Helper from "@ember/component/helper"
import { get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import { inject as service } from "@ember/service"
import _ from "lodash"
import { all } from "rsvp"

export function eHasMany(params) {
  let [model, keyName, relationshipType] = params

  class ObjectPromiseProxy extends ArrayProxy.extend(PromiseProxyMixin) {}

  let ids = get(model, keyName)
  return ObjectPromiseProxy.create({
    promise: all(_.map(ids, (id) => get(this, "store").find(relationshipType, id))),
  })
}

class EHasMany extends Helper {
  @service("ember-store")
  store

  compute = eHasMany
}
